// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"183":"information","302":"ad-account","594":"about","792":"main","883":"shop"}[chunkId] + "." + {"183":"fde87ddd","302":"8ea98c51","594":"c3f3b55b","792":"4b90abd4","883":"8b057259"}[chunkId] + ".css";
};